import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("path", {
  d: "M0 1.6C0 0.716345 0.716344 0 1.6 0H4.26667V4.26667H0V1.6Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M0 5.33333V14.4C0 15.2837 0.716345 16 1.6 16H4.26667V5.33333H0Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M5.33333 16H14.4C15.2837 16 16 15.2837 16 14.4V5.33333H5.33333V16Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M16 4.26667V1.6C16 0.716344 15.2837 0 14.4 0H5.33333V4.26667H16Z",
  fill: "currentColor"
}, null, -1)

import VIconBase from '../VIconBase.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'LayoutIcon',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(VIconBase, {
    name: "layout",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      _hoisted_3,
      _hoisted_4
    ]),
    _: 1
  }))
}
}

})